import Dashboard from "./components/Pages/Dashboard/Dashboard.tsx";
import SignIn from "./components/Pages/Login/SignIn.tsx";
import SignUp from "./components/Pages/Login/SignUp.tsx";
import Code from "./components/Pages/Login/Code.tsx";
import Metrics from "./components/Pages/Metrics/Metrics.tsx";
import MemberEdit from "./components/Pages/Register/MemberEdit.tsx";
import Register from "./components/Pages/Register/Register.tsx";
import Settings from "./components/Pages/Settings/Settings.tsx";
import AuthWithCode from "./components/Pages/AuthenticateCode/AuthWithCode.tsx";
import TasksList from "./components/Pages/Tasks/TasksList.tsx";
import TaskEdit from "./components/Pages/Tasks/TaskEdit.tsx";
import TaskView from "./components/Pages/Tasks/TaskView.tsx";
import Tools from "./components/Pages/Tools/Tools.tsx";
import ToolsEdit from "./components/Pages/Tools/ToolsEdit.tsx";
import TaskAval from "./components/Pages/Tasks/TaskAval.tsx";
import TaskVersion from "./components/Pages/Tasks/TaskVersion.tsx";
import Pocketnaro from "./components/Pages/Pocketnaro/Pocketnaro.tsx";
import PublicTaskSearch from "./components/Pages/PublicTaskSearch/PublicTaskSearch.tsx";


//Quadros
import Boards from "./components/Pages/Settings/Boards/Boards.tsx";
import BoardEdit from "./components/Pages/Settings/Boards/BoardsEdit.tsx";

//Status
import Status from "./components/Pages/Status/Status.tsx";
import StatusEdit from "./components/Pages/Status/StatusEdit.tsx";

//Profile
import Profile from "./components/Pages/Profile/Profile.tsx";

//Actions
import Actions from "./components/Pages/Action/Actions.tsx";

const AppRoutes = [
  {
    index: true,
    element: <Dashboard />,
    path: '/',
  },
  {
    path: '/dash',
    element: <Dashboard />
  },
  {
    path: '/metric',
    element: <Metrics />
  },
  {
    path: '/register',
    element: <Register />
  },
  {
    path: '/settings',
    element: <Settings />
  },
  {
    path: '/authenticate/:code',
    element: <AuthWithCode />
  },
  {
    path: '/signin',
    element: <SignIn />
  },
  // {
  //   path: '/signup',
  //   element: <SignUp />
  // },
  {
    path: '/code',
    element: <Code />
  },
  {
    path: '/member/edit/:id',  
    element: <MemberEdit />  
  },
  {
    path: '/task/edit/:id',
    element: <TaskEdit />
  },
  {
    path: '/tasks/:type',
    element: <TasksList />
  },
  {
    path: '/task/view/:id',
    element: <TaskView />
  },
  {
    path: '/tasks/versions/:type',
    element: <TaskVersion />
  },
  {
    path: '/tools',
    element: <Tools />
  },
  {
    path: '/tool/edit/:id',
    element: <ToolsEdit />
  },
  {
    path: '/task/aval/:id/:user',
    element: <TaskAval />
  },
  {
    path: '/boards',
    element: <Boards />
  },
  {
    path: '/board/edit/:id',
    element: <BoardEdit />
  },
  {
    path: '/pocketnaro',
    element: <Pocketnaro />
  },
  {
    path: '/status',
    element: <Status />
  },
  {
    path: '/status/edit/:id',
    element: <StatusEdit />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '/actions',
    element: <Actions />
  },
  {
    path: '/public/tasks',
    element: <PublicTaskSearch />
  }
];

export default AppRoutes;
